export default {
    moodsNew: [
        { label: 'Completely Chill', value: 100 },
        { label: 'Content', value: 75 },
        { label: 'Somewhere in Between', value: 50 },
        { label: 'Anxious', value: 25 },
        { label: 'Super Stressed', value: 1 }
    ]
};
